import { defineMessage } from 'services/localization';

export const messages = {
    connectedTitle: defineMessage('integrationname_connection_error'),
    connectedManagerDescription: defineMessage('request_can_not_be_crea_portlink_for_assistance'),
    connectedUserDescription: defineMessage('request_can_not_be_crea__please_try_again_later'),
    disconnectedTitle: defineMessage('disconnected_from_integrationname'),
    disconnectedManagerDescription: defineMessage('request_can_not_be_crea_en_disabled_please_link'),
    reconnectLinkText: defineMessage('reconnect_to_integrationname'),
    disconnectedUserDescription: defineMessage('request_can_not_be_crea_y_for_the_inconvenience'),
    closePopup: defineMessage('close'),
};
